/** @file Which key selection a keyframe form's status belongs to (frames included, fx1 T-464 minor). */
import type { SubmitResult } from '../../forms/submitCalls';
import type { KeyRef } from '../../stores/types';

/** A submit's result and the identity of the keys it is about. */
export interface KeyStatus { result: SubmitResult; keys: string }

const idOf = (keys: readonly KeyRef[]): string => keys.map((k) => `${k.animation}/${k.target}/${k.channel}/${k.frame}`).join('|');

/** The form instance lives per channel (a move keeps it); its status is shown only for the very keys it is about. */
export const keyStatus = {
  /** The status a submit on `keys` leaves: a success that selects `next` (the form's own move) hands it to `next`. */
  after(result: SubmitResult, keys: readonly KeyRef[], next?: readonly KeyRef[]): KeyStatus {
    return { result, keys: idOf(result.error === null && next !== undefined ? next : keys) };
  },
  /** The result to show while `keys` are selected, or null for a status left by other keys. */
  shown(status: KeyStatus | null, keys: readonly KeyRef[]): SubmitResult | null {
    return status !== null && status.keys === idOf(keys) ? status.result : null;
  },
};
